module.exports = __webpack_public_path__ + "img/houtai_bisaishuju.29297e02.png";